import { render } from "./HowItWorks2Icon.vue?vue&type=template&id=14219f88"
import script from "./HowItWorks2Icon.vue?vue&type=script&lang=js"
export * from "./HowItWorks2Icon.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__